import React, { useState } from "react";
import { Redirect } from "react-router-dom";

import { GET_APPLICATION_INFO } from "../../../api/gql";
import withQuery from "../wrappers/gql/withQuery";

import { URI_PATHS } from "../../../constants";

import { useApplicationState, useCurrentStep } from "../../../state/store/customHooks";
import { determineStepDescription } from "../../../utilities/onboardingSteps";

import ContinueButton from "../common/ContinueButton";
import Loading from "../../common/Loading";

const ResumeApplicationV2 = ({ data: applicationInfo }) => {
  const { applicationStatus } = applicationInfo.getApplicationInfo;
  const [ resumeStep, setResumeStep ] = useState(false);

  const currentStep = useCurrentStep();
  const stepOrder = useApplicationState("stepOrder");
  const configFetched = useApplicationState("configFetched");

  // get rid of showing basic info
  const formattedStepOrder = stepOrder
    .slice(1, stepOrder.length)
    .map((step) => ({ step, description: determineStepDescription(step) }));

  // need to subtract by 1 here since we're getting rid of showing basic info
  const currentStepIndex = useApplicationState("currentStepIndex") - 1;
  const previousSteps = formattedStepOrder.slice(0, currentStepIndex);

  const stepItems = formattedStepOrder.map((step) => {
    const { step: stepName, description } = step;
    const showStepComplete = previousSteps.includes(step);
    const inCurrentStep = stepName === currentStep;

    return (
      <li key={stepName} className={`${inCurrentStep ? "font-bold" : ""}`}>
        <div className="flex justify-between items-center">
          <span>{description}</span>
          {showStepComplete && <i className="far fa-solid fa-check text-primary" />}
        </div>
      </li>
    );
  });

  if(applicationStatus)
    return <Redirect to={URI_PATHS.DECISION} />;

  if(!configFetched)
    return <Loading />;

  if(!resumeStep)
    return (
      <>
        <div className="outerStack-mobile sm:outerStack">
          <div className="stepDescriptionText">Application Process</div>
          <div className="innerStack">
            <div className="text-left text-xl md:text-2xl">
              <div className="px-8 ml-10">
                <ol className="list-decimal">
                  {stepItems}
                </ol>
              </div>
            </div>
          </div>
        </div>
        <ContinueButton onClick={() => setResumeStep(true)} />
      </>
    );

  return <Redirect to={{ pathname: URI_PATHS[currentStep] }} />;
};

export default withQuery(GET_APPLICATION_INFO)(ResumeApplicationV2);